import { createSimpleWrapper } from "../tag/createSimpleWrapper";
export const CardFooter = createSimpleWrapper("div", "card-footer");
